import { render, staticRenderFns } from "./TheRegistrationForm.vue?vue&type=template&id=b55bfcf4&scoped=true"
import script from "./TheRegistrationForm.vue?vue&type=script&lang=js"
export * from "./TheRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./TheRegistrationForm.vue?vue&type=style&index=0&id=b55bfcf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55bfcf4",
  null
  
)

export default component.exports